
import React from 'react';
import ReactDOM from 'react-dom/client';
import Payment from './Payment';
import './App.css';

const App = () => {
  return (
    <div>
  <h1 className="enterprise-label">Welcome to the Donation Page</h1>
      <Payment />
    </div>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);
